import { createApp } from 'vue'
import UserList from '../components/users/UserList.vue';

// User List
if (document.getElementById('users-list-container')) {
  var users = createApp({})
  users.component('UserList', UserList)
  users.mount('#users-list-container')
}